/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
// console.log( 'Hello World! (from create-block-cover-filter-block block)' );
/* eslint-enable no-console */

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.wp-block-cover').forEach((cover) => {
		const button = cover.querySelector('.wp-block-cover__play-button');
		const video = cover.querySelector('.wp-block-cover__video-background');
		const innerContainer = cover.querySelector('.wp-block-cover__inner-container');

		if (button && video && innerContainer) {
			// Définir les transitions une seule fois
			[button, innerContainer].forEach((el) => {
				el.style.transition = 'opacity 0.8s cubic-bezier(0.4, 0, 0.2, 1)';
			});

			// Lecture uniquement via le bouton
			button.addEventListener('click', (e) => {
				e.stopPropagation(); // Empêche la propagation du clic au parent
				if (video.paused) {
					video.play();
					button.style.opacity = '0';
					innerContainer.style.opacity = '0';
				}
			});

			// Pause via clic sur la couverture ou le bouton
			cover.addEventListener('click', () => {
				if (!video.paused) {
					video.pause();
					button.style.opacity = '1';
					innerContainer.style.opacity = '1';
				}
			});
		}
	});
});
